// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbLink":"Breadcrumbs_breadcrumbLink__OBN8v"};